import PropTypes from 'prop-types';
import React from 'react';
import { css } from '@emotion/core';
import { UIPaymentMethodEnum, PayMethodEnum, PaymentFormLabels } from './paymentConstants';
import { Radio, RadioGroup, FormControlLabel, FormControl, FormLabel, Typography } from '@material-ui/core';

const PaymentMethodOptions = ({ selectedPaymentMethod, isCardEligible, handlePaymentMethodOnChange }) => {
  const handleOnChange = (event) => {
    handlePaymentMethodOnChange(event.target.value);
  };

  return (
    <FormControl
      fullWidth={true}
      data-testid="payment-method-container"
      css={css`
        margin: 0 0 16px 0;
        .MuiRadio-colorSecondary.Mui-checked {
          color: rgb(24, 30, 58);
      `}
    >
      <FormLabel id="payment-method-label">
        <Typography variant="h5" component="span" color="textPrimary">
          {PaymentFormLabels.PAYMENT_METHOD}
        </Typography>
      </FormLabel>
      <RadioGroup
        row
        aria-labelledby="payment-method-label"
        value={selectedPaymentMethod}
        name="payment-method-group"
        onChange={handleOnChange}
      >
        <FormControlLabel
          value={PayMethodEnum.CHECKING}
          control={<Radio />}
          label={UIPaymentMethodEnum.echeck}
          css={css`
            margin-right: 40px;
          `}
        />
        <FormControlLabel
          value={PayMethodEnum.SAVINGS}
          control={<Radio />}
          label={UIPaymentMethodEnum.savings}
          css={css`
            margin-right: 40px;
          `}
        />
        {isCardEligible && (
          <FormControlLabel value={PayMethodEnum.CARD} control={<Radio />} label={UIPaymentMethodEnum.card} />
        )}
      </RadioGroup>
    </FormControl>
  );
};

PaymentMethodOptions.propTypes = {
  selectedPaymentMethod: PropTypes.string.isRequired,
  isCardEligible: PropTypes.bool,
  handlePaymentMethodOnChange: PropTypes.func.isRequired,
};

export default PaymentMethodOptions;
